<script>
export default {
    name: "ConstructionModalDetailsTab",
    props: {
        construction: {required: true},
        shows: {required: false, default: []},
    }
}
</script>

<template>
        <div class="row">
            <div class="col-lg-2 col-md-4 col-xs-12">
                <img v-if="construction.highlight" v-bind:src="construction.highlight"
                     width="100%" class="border-img" style="cursor: pointer"/>
                <div v-if="!construction.photos || !construction.photos.length" style="width: 100%;min-height: 140px; display: block;">
                    <div style="text-align: center;">
                        <i class="fa fa-photo border-img"
                           style="font-size: 50px; line-height: 140px; height: 140px; opacity: .5; width: 100%; text-align: center;"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-xs-12" style="margin-top: 15px;">
                        <span v-if="construction.status_name">{{ construction.status_name }}</span>
                        <span>
                            <i class="fa fa-circle text-success" v-if="construction.status === 1" title="Livre" v-tooltip></i>
                            <i class="fa fa-circle text-danger" v-if="construction.status === 4" title="Suspenso" v-tooltip></i>
                            <i class="fa fa-circle text-primary" v-if="construction.status === 3 || construction.status === 7" title="Vendido" v-tooltip></i>
                            <i class="fa fa-circle font-blue" v-if="construction.status === 5 || construction.status === 8" title="Alugado" v-tooltip></i>
                            <i class="fa fa-circle text-warning" v-if="construction.status === 6" title="Reservado" v-tooltip></i>
                            <i class="fa fa-circle font-orange" v-if="construction.status === 2 || construction.status === 9" :vtitle="construction.status_name" v-tooltip></i>
                        </span>
                    </div>
                    <div class="col-lg-6 col-xs-12 pull-right text-right" style="margin-top: 15px;">
                        <span v-if="construction.situation_name">{{ construction.situation_name }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6" style="margin-top: 15px;">
                        <strong>Cadastrado:</strong><br><span>{{ construction.resource_created_at | date }}</span>
                    </div>
                    <div class="col-xs-6 pull-right text-right" style="margin-top: 15px;">
                        <strong>Atualizado:</strong><br><span>{{ construction.resource_created_at | date }}</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-10 col-md-8 col-xs-12">
                <div class="row">
                    <div class="col-xg-6 col-lg-6 col-xs-12">
                        <div class="portlet light-grey" style="height: 110px; max-height: 110px; overflow-y: auto;">
                            <div class="row" style="margin-bottom: 8px;">
                                <div class="col-xs-6">
                                    <span><strong>Código:</strong> <span>{{ construction.code }}</span></span>
                                </div>
                                <div class="col-xs-6">
                                    <strong>Cód. alternativo: </strong>
                                    <span v-if="construction.alternative_code">{{ construction.alternative_code }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <p  v-if="construction.keys">
                                <a href="javascript:;" class="btn btn-xs blue"
                                   @click="$emit('shows', 'keys')">
                                    <span v-if="shows['keys']">Exibir Local das Chaves</span>
                                    <span v-else>Ocultar</span>
                                </a>
                                <span v-if="shows['keys']">{{ construction.keys ?? 'Localização não fornecida' }}</span>
                                <span v-else></span>
                            </p>
                            <p v-else>
                                Chave não disponível.
                            </p>
                        </div>
                    </div>
                    <div class="col-xg-6 col-lg-6 col-xs-12">
                        <div class="portlet light-grey" style="height: 110px; max-height: 110px; overflow-y: auto;">
                            <p>
                                <span><strong>Localização:</strong>
                                    <span>{{ construction.neighborhood && construction.neighborhood.name }} - {{ construction.city && construction.city.name }}</span>
                                </span>
                            </p>
                            <p>
                                <a href="javascript:;" class="show-location-info btn btn-xs blue"
                                   @click="$emit('shows', 'address')">
                                    <span v-if="!shows['address']">Exibir Endereço</span>
                                    <span v-if="shows['address']">Ocultar</span>
                                </a>
                                <span v-if="shows['address']">
                                    {{ construction.street }} {{ construction.street_number }}
                                    <span v-if="construction.building && construction.building.name"> - {{ construction.building.name }}</span>
                                    <span v-if="construction.zipcode"> - CEP: {{ construction.zipcode }}</span>
                                </span>
                            </p>
                            <p v-if="construction.reference_point">
                                <a href="javascript:;" class="show-location-info btn btn-xs blue"
                                   @click="$emit('shows', 'referece_point')">
                                    <span v-if="!shows['referece_point']">Exibir Ponto de Referência</span>
                                    <span v-if="shows['referece_point']">Ocultar</span>
                                </a>
                                <span v-if="shows['referece_point']">{{ construction.reference_point }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xg-6 col-lg-6 col-xs-12">
                        <div class="portlet light" style="padding-top: 0;padding-bottom: 0;">
                            <p>
                                                        <span>
                                                            <strong style="font-size: 16px;">Venda: </strong>
                                                            <span style="font-size: 16px;" v-if="construction.sell_price">
                                                                {{ construction.sell_price | money }}
                                                            </span>
                                                            <span v-else>-</span>
                                                        </span>
                                <span style="margin-left: 30px;">
                                                            <strong style="font-size: 16px;">Locação: </strong>
                                                            <span style="font-size: 16px;" v-if="construction.rent_price">
                                                                {{ construction.rent_price | money }}/mês
                                                            </span>
                                                            <span v-else>-</span>
                                                        </span>
                            </p>
                        </div>
                    </div>
                    <div class="col-xg-6 col-lg-6 col-xs-12">
                        <div class="portlet light" style="padding-top: 0;padding-bottom: 0;">
                            <p>
                                <strong>Distância relativa: </strong>
                                <span v-if="construction.relative_distance > 0">
                                                            {{ construction.relative_distance }}
                                                        </span>
                                <span v-if="construction.relative_distance_to">
                                                            {{ construction.relative_distance_to }}
                                                        </span>
                                <span v-else>-</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="(construction.type != 11 && construction.type != 17)">
                    <div class="col-lg-6 col-xs-12">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Dorms</strong>
                                    <span v-if="construction.count_dorm > 0">{{ construction.count_dorm }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Suítes</strong>
                                    <span v-if="construction.count_suit > 0">{{ construction.count_suit }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Salas</strong>
                                    <span v-if="construction.count_room > 0">{{ construction.count_room}}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Coz.</strong>
                                    <span v-if="construction.count_kitchen > 0">{{ construction.count_kitchen }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-lg-6 col-xs-12">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Banh.</strong>
                                    <span v-if="construction.count_bathroom > 0">{{ construction.count_bathroom }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Vagas</strong>
                                    <span v-if="construction.count_car_garage > 0">{{ construction.count_car_garage }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Dep. Emp.</strong>
                                    <span v-if="construction.count_housekeeper_room > 0">{{ construction.count_housekeeper_room }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Lavabos</strong>
                                    <span v-if="construction.count_lavatory > 0">{{ construction.count_lavatory }}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-xs-12">
                        <div class="row">
                            <div class="col-lg-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Área T. Útil</strong>
                                    <span>{{ construction.area_total }}</span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Área T. Constr.</strong>
                                    <span>{{ construction.total_built_area }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xs-12">
                        <div class="row">
                            <div class="col-lg-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Dimensão</strong>
                                    <span>{{ construction.area_width }} x {{ construction.area_height }} {{ construction.measure_unit }}</span>
                                </div>
                            </div>
                            <div class="col-lg-6 col-xs-12">
                                <div class="portlet light-grey text-center composition-modal-content">
                                    <strong>Área Total</strong>
                                    <span>{{ construction.area_total }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-lg-6">
                        <div class="portlet light" style="padding-top: 0;padding-bottom: 0;">
                            <p>
                                                        <span>
                                                            <strong>Valor Área Total: </strong>
                                                            <span v-if="construction.total_area_price">
                                                                {{ construction.total_area_price | money }}/mês
                                                            </span>
                                                            <span v-else>-</span>
                                                        </span>
                                <span style="margin-left: 30px;">
                                                            <strong>Valor Área Constr.: </strong>
                                                            <span v-if="construction.built_area_price">
                                                                {{ construction.built_area_price | money }}
                                                            </span>
                                                            <span v-else>-</span>
                                                        </span>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-6">
                        <div class="portlet light" style="padding-top: 0;padding-bottom: 0;">
                            <p>
                                                        <span>
                                                            <strong>Posição: </strong>
                                                            <span v-if="construction.orientation_name">
                                                                {{ construction.orientation_name }}
                                                            </span>
                                                            <span v-else>-</span>
                                                        </span>
                                <span style="margin-left: 30px;">
                                                            <strong>Ano de construção{{ calculatedAge }}: </strong>
                                                            <span v-if="construction.construction_year">
                                                                {{ construction.construction_year }}
                                                            </span>
                                                            <span v-else>-</span>
                                                        </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="construction.approval_status == 3">
                    <div class="col-xs-12 col-lg-10">
                        <div class="portlet light" style="padding-top: 0;padding-bottom: 0;">
                            <p>
                                                        <span>
                                                            <strong>Avaliador: </strong>
                                                            <span>
                                                                {{construction.approval.name}}
                                                            </span>
                                                        </span>
                            </p>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-12">
                        <div class="portlet light" style="padding-top: 0;padding-bottom: 0;">
                            <p>
                                                        <span>
                                                            <strong>Comentário: </strong>
                                                        </span>
                            </p>
                            <div v-if="shows['approval_comment']">
                                {{construction.approval.comment}}
                            </div>
                            <div v-else>
                                <button class="btn btn-info" @click="$emit('shows', 'approval_comment')"> Exibir Comentário</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionModalDetailsTab.vue?1c49e942